export const slugify = (text: string) => {
  // Normalize the text to decompose combined characters
  text = text.normalize("NFKD");
  // Remove all non-ASCII characters
  text = text.replace(/[^\w\s-]/g, "");
  // Replace spaces and repeated hyphens with a single hyphen
  text = text.replace(/[-\s]+/g, "-");
  // Convert to lowercase
  text = text.toLowerCase();
  // Strip hyphens from the start and end
  text = text.replace(/^-+|-+$/g, "");
  return text;
};

export const deslugify = (slug: string) => {
  if (!slug) {
    return "";
  }
  let text = slug.replace(/-/g, " ");
  // Capitalize the first letter of each word
  text = text.replace(/\b\w/g, (char) => char.toUpperCase());
  return decodeURIComponent(text);
};
